import { createI18n } from "vue-i18n";

const messages = {
  en: {
    email: "E-mail",
    code: "Code",
    password: "Password",
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    firstName: "First Name",
    lastName: "Last Name",
    company: "Company",
    address: "Address",
    country: "Country",
    city: "City",
    phoneNumber: "Phone Number",
    identityNumber: "Identity Number",
    time: "Time",
    timezone: "Timezone",
    bactToLogin: "Back to Sign In",
    pleaseWait: "Please wait...",
    comingSoon: "Coming Soon",
    signOut: "Sign Out",
    account: "Account",
    loadMore: "Load More",
    search: "Search...",
    prev: "Prev",
    next: "Next",
    guideName: "Guide Name",
    createdAt: "Created At",
    updatedAt: "Updated At",
    uploadImage: "Upload Image",
    active: "Active",
    passive: "Passive",
    status: "Status",
    description: "Description",
    FAILURE: "FAILURE",
    OK: "OK",
    MISSING: "MISSING",
    lampReplacement: "Lamp Replacement",
    batteryReplacement: "Battery Replacement",
    batteryConnection: "Battery Connection",
    menuitems: {
      myProjects: "MY PROJECTS",
      luminaries: "Luminaries",
      subscriptions: "Subscription",
      reports: "Reports",
      settings: "Settings",
    },
    language: {
      title: "Language",
      languages: { turkish: "Turkish", english: "English" },
    },
    footer: {
      privacyPolicy: "Privacy Policy",
      kvkkPolicy: "PDPL Policy",
      refundPolicy: "Refund Policy",
      contact: "Contact",
      aboutUs: "About Us",
      distanceSalesAgreement: "Distance Sales Agreement",
      developBy: "Design & Develop by {image}",
    },
    //***  Auth Pages */
    signIn: {
      title: "Sign In",
      headerTitle: "Welcome back to Luminula!",
      subText: "Sign in to continue to Luminula.",
      noAccountButtonLabel: "Don't have an account?",
      createAnAccount: "Create an Account",
      forgotPassword: "Forgot Password",
      successMessage: "Welcome!",
      buttonText: "Sign In",
    },
    signUp: {
      title: "Sign Up",
      subText: "Fill out the form below to create a new account.",
      passwordInfoText: "Please use with a mix of letters,numbers & symbols",
      hasAccount: "Have an account?",
      signIn: "Sign in here",
      createAccount: "Create an Acoount",
      successMessage:
        "Your account has been created. Please confirm your account with the confirmation code we sent to your e-mail.",
      buttonText: "Sign Up",
    },
    forgotPassword: {
      title: "Forgot Password?",
      subText:
        "Please enter your email address and we'll send you instructions on how to reset your password.",
      successMessage:
        "Your request has been successfully received. Please check your e-mail.",
      buttonText: "Recover Password",
    },
    resetPassword: {
      title: "Set Your New Password",
      subText:
        "Enter your e-mail ,code and new password to set your new password",
      successMessage:
        "Password changed successfully. Please login with your new password.",
      buttonText: "Reset Password",
    },
    verifyCode: {
      title: "Confirm Account",
      subText: "Confirmation code sent. Please check your e-mail.",
      buttonText: "Confirm Account",
    },
    //***  Auth Pages End */
    notFoundPage: {
      title: "Page Not Found 🕵🏻‍♀️",
      text: "Oops! 😖 The requested page was not found on this server.",
      button: "Back to platform",
    },
    luminaries: {
      title: "Luminaries",
      addNewProject: "Add New Project",
      status: "Status",
      updatedAt: "Updated At",
      lastTestTime: "Last Test Time",
      actionNeeded: "Action Needed",
      noProjectInfoText: "There are no registered project.",
      hasNotDeviceInfoText: "There is no device for this project.",
      notSubscriptionMessage: "Please subscribe to see the content.",
      projectName: "Project Name",
      notSubscriptionButton: {
        text: "Click {button} to subscribe.",
        button: "here",
      },
      add: {
        title: "Add New Project",
        projectName: "Project Name",
        successMessage: "Operation Successful! Created project.",
      },
      devices: {
        delete: {
          modalTitle: "Delete Device",
          modalText: "Are you sure you want to delete the device?",
          successMessage: "Operation Successful! Device deleted.",
        },
      },
    },
    subscription: {
      subscriptionDetails: "Subscription Details",
      validUntil: "Valid Until: {date}",
      renewalDate: "Renewal Date: {date}",
      expiryDate: "Expiry Date: {date}",
      subscriptionStartDate: "Subscription Start Date: {date}",
      totalLuminary: "Total Luminary: {luminary}",
      subscriptionPlan: "Subscription Plan: {plan}",
      monthly: "Monthly",
      yearly: "Yearly",
      subscriptionMonthly: "Subscription Monthly",
      subscriptionYearly: "Subscription Yearly",
      cancelSubscription: "Cancel Subscription",
      cancelSubscriptionModalText:
        "Are you sure you want to cancel your subscription?",
      cancelSubscriptionSuccessMessage:
        "Operation Successful! Your subscription has been cancelled.",
      upgradeSubscription: "Upgrade to Yearly Plan",
      successMessage: "Operation Successful! You subscribed.",
      subscriptionStatus: "Subscription Status",
      aMonthFreeTrial: {
        text: "{trial} for your first subscription",
        trial: "+1 Month Free Trial",
      },
      daysRemaining: "{day} Days Remaining",
      subscribe: "Subscribe",
      subscriptionStatusTypes: {
        INACTIVE: "INACTIVE",
        ACTIVE: "ACTIVE",
        PENDING: "PENDING",
        UNPAID: "UNPAID",
        UPGRADED: "UPGRADED",
        CANCELED: "CANCELED",
        EXPIRED: "EXPIRED",
        PAYMENTDUE: "PAYMENT-DUE",
      },
      changePaymentMethod: "Change Payment Method",
      subscriptionPayment: "Subscription Payment",
      paymentLoadInfoText: "Your information is being checked. Please wait...",
      paymentPageErrorText: "Oops! Something went wrong!",
      cancelOperation: "Cancel Operation",
      paymentInformation: {
        title: "Payment Information",
        description: "We never store credit card information.",
        cardNumber: "Card Number",
        nameOnTheCard: "Name On The Card",
        cvvTooltipText: "Kart CVV kodunu girin",
        expirationDate: "Expiration Date",
        monthlySubscription: "Monthly subscription",
        oneYearSubscription: "1 year subscription",
        threeYearSubscription: "3 year subscription",
      },
    },
    reports: {
      generateAReport: "Generate a Report",
      retrieveAnOlderReport: "Retrieve an Older Report",
      reportName: "Report Name",
      notSubscriptionMessage: "Please subscribe to see the content.",
      add: {
        successMessage:
          "Operation Successful! Generated new report for luminarie.",
      },
    },
    settings: {
      timezone: {
        modalTitle: "Change Timezone",
        selectTimezone: "Select Timezone",
        successMessage: "Operation Successful! The timezone has been changed.",
      },
      changePassword: {
        modalTitle: "Change Password",
        successMessage:
          "Operation Successful! The password has been changed successfully. Please login with your new password.",
        currentPasswordIsWrongMessage: "The current password is incorrect.",
      },
      billingInformation: {
        title: "Billing Information",
        selectCountry: "Select Country",
        selectCity: "Select City",
        successMessage:
          "Operation Successful! Billing information has been updated.",
      },
    },
    administration: {
      title: "Administration",
      userGuides: "User Guides",
      newGuide: "New Guide",
      images: "Images",
      addText: "Add Text",
      addTranslation: "Add Translation",
      isItActive: "Is it active?",
      add: {
        successMessage: "Operation Successful! A new guide has been created.",
      },
      edit: {
        title: "Edit Guide",
        successMessage: "Operation Successful! Guide updated.",
      },
      detail: {
        selectLocale: "Select Language",
        warningMessage: "Make sure you add the picture and description.",
        successMessage: "Operation Successful! Guide updated.",
      },
      delete: {
        modalTitle: "Delete Guide",
        modalText: "Are you sure you want to delete the guide?",
        successMessage: "Operation Successful! Guide deleted.",
        guideItem: {
          modalTitle: "Delete Guide Image",
          modalText:
            "Are you sure you want to remove this image from this guide?",
          successMessage: "Operation Successful! Image deleted from guide.",
        },
      },
    },
    contact: {
      title: "Contact",
      subText: "Contact us for information.",
      successMessage: "Operation Successful! Your message has been received.",
    },
    form: {
      message: {
        email: "Must be valid e-mail address",
        required: "This value is required.",
        passwordsMustMatch: "Passwords must match.",
        passwordsNotMustMatch:
          "New password must be different than current password.",
        numeric: "This field may only contain numeric characters.",
        cardNumber: "Card information must be correct.",
        min: "This field must be at least {value} characters.",
        select: "Select at least one option.",
        passwordRegex:
          "This field must contain at least one number, one lowercase letter, and one uppercase letter. It can't contain spaces or special characters.",
        passwordRegexFormat:
          "This field must contain at least one number, one lowercase letter, and one uppercase letter.",
        phoneNumberFormat:
          "Please make sure you enter the correct phone number.",
      },
    },
    datePicker: {
      startDate: "Start Date",
      endDate: "End Date",
      pickAMonth: "Pick a month",
    },
    selectBox: {
      noDataText: "No data",
      noMatchText: "No matching data",
    },
    table: {
      tableEmptyText: "There are no records to show",
      emptyFilteredText: "There are no records matching your request",
    },
    notify: {
      error: {
        error: "Error",
        title: "There was an error.",
        buttonText: "Please try again!",
      },
      success: {
        success: "Success",
        title: "Operation Successful!",
        buttonText: "Continue!",
      },
    },
    phoneNumberInput: {
      countrySelector: {
        placeholder: "Country code",
        error: "Choose country",
      },
      phoneInput: {
        placeholder: "Phone number",
        example: "Example:",
      },
    },
    buttons: {
      submit: "Submit",
      approve: "Approve",
      close: "Close",
      delete: "Delete",
      deleteDevice: "Delete Device",
      save: "Save",
      remove: "Remove",
      okey: "OK",
      repeat: "Repeat",
      update: "Update",
      cancel: "Cancel",
      yes: "Yes",
      no: "No",
      upload: "Upload",
      download: "Download",
      send: "Send",
      choose: "Choose",
      change: "Change",
      selectAll: "Select All",
      clear: "Clear",
      tryAgain: "Try Again",
      start: "Start",
      launch: "Launch",
      continue: "Continue",
      edit: "Edit",
      yesIAccept: "Yes, I accept",
      detail: "Detail",
    },
    awsCognitoErrorCodes: {
      InvalidPasswordException:
        "Password does not conform to policy: Password not long enough",
      ExpiredCodeException:
        "Invalid code provided, please request a code again.",
      LimitExceededException:
        "Attempt limit exceeded, please try after some time.",
      NotAuthorizedException: "Incorrect username or password.",
      CodeMismatchException:
        "Invalid verification code provided, please try again.",
      InvalidParameterException:
        "The value you have entered is either missing or the entered value length is short.",
      PasswordResetRequiredException:
        "Password reset required for the user. Please request a password reset.",
      UserNotFoundException: "User not found.",
      UserNotConfirmedException: "User not confirmed.",
      UsernameExistsException:
        "There is already a registered user with this email address. Please register with another e-mail address.",
    },
    errorCodes: {
      errorMsg: "There was an error. Please try again.",
      UserAttributesRequired:
        "Your billing information for the subscription is missing. Please fill in the required information.",
      "500": "Internal Server Error",
      "404": "Requested resource not exists",
      "409": "Requested resource exists",
    },
    iyzicoErrorCodes: {
      InvalidEmailAddress: "Invalid email address.",
      InvalidIdentityNumber: "Invalid identity number.",
      InvalidPhoneNumber: "Invalid phone number.",
      InvalidAddress: "Invalid address.",
      InvalidCity: "Invalid city information.",
      InvalidCountry: "Invalid country information.",
      RetryAgainLater: "Please retry operation later.",
    },
  },
  tr: {
    email: "E-posta",
    code: "Kod",
    password: "Şifre",
    oldPassword: "Eski Şifre",
    newPassword: "Yeni Şifre",
    confirmPassword: "Şifreyi Yinele",
    firstName: "Ad",
    lastName: "Soyad",
    address: "Adres",
    country: "Ülke",
    city: "Şehir",
    phoneNumber: "Telefon Numarası",
    identityNumber: "Kimlik Numarası",
    company: "Şirket",
    time: "Zaman",
    timezone: "Saat Dilimi",
    bactToLogin: "Giriş Yap'a geri dön",
    pleaseWait: "Lütfen bekleyiniz...",
    comingSoon: "Çok Yakında",
    signOut: "Çıkış Yap",
    account: "Hesap",
    loadMore: "Daha Fazla Yükle",
    search: "Ara...",
    prev: "Önceki",
    next: "Sonraki",
    guideName: "Kılavuz Adı",
    createdAt: "Oluşturma Tarihi",
    updatedAt: "Güncelleme Tarihi",
    uploadImage: "Resim Yükle",
    active: "Aktif",
    passive: "Pasif",
    status: "Durum",
    description: "Açıklama",
    FAILURE: "ARIZA",
    OK: "TAMAM",
    MISSING: "KAYIP",
    lampReplacement: "Lamba Değiştirme",
    batteryReplacement: "Pil Değiştirme",
    batteryConnection: "Batarya Bağlantısı",
    menuitems: {
      myProjects: "PROJELERİM",
      luminaries: "Armatürler",
      subscriptions: "Abonelik",
      reports: "Raporlar",
      settings: "Ayarlar",
    },
    language: {
      title: "Diller",
      languages: { turkish: "Türkçe", english: "İngilizce" },
    },
    footer: {
      privacyPolicy: "Gizlilik Sözleşmesi",
      kvkkPolicy: "KVKK Politikası",
      refundPolicy: "İade Politikası",
      contact: "İletişim",
      aboutUs: "Hakkımızda",
      distanceSalesAgreement: "Mesafeli Satış Sözleşmesi",
      developBy: "Tasarım & Geliştirme {image}",
    },
    //***  Auth Pages */
    signIn: {
      title: "Giriş Yap",
      headerTitle: "Luminula'ya tekrar hoş geldin!",
      subText: "Luminula'ya devam etmek için oturum açın.",
      noAccountButtonLabel: "Hesabınız yok mu?",
      createAnAccount: "Hesap Oluştur",
      forgotPassword: "Şifremi Unuttum",
      successMessage: "Hoş geldiniz!",
      buttonText: "Giriş Yap",
    },
    signUp: {
      title: "Kayıt Ol",
      subText: "Yeni bir hesap oluşturmak için aşağıdaki formu doldurunuz.",
      passwordInfoText:
        "Lütfen güvenliğiniz için şifrenizi belirlerken bir harf, sayı ve sembol kullanın.",
      hasAccount: "Bir hesabınız var mı?",
      signIn: "Giriş yap",
      createAccount: "Hesap Oluşturun",
      successMessage:
        "Hesabınız oluşturuldu. Lütfen e-postanıza gönderdiğimiz onay kodu ile hesabınızı onaylayınız.",
      buttonText: "Kayıt Ol",
    },
    forgotPassword: {
      title: "Şifrenizi mi unuttunuz?",
      subText:
        "Lütfen e-posta adresinizi girin, size şifrenizi nasıl sıfırlayacağınızla ilgili talimatlar gönderelim.",
      successMessage:
        "İsteğiniz başarıyla alındı. Lütfen e-postanızı kontrol ediniz.",
      buttonText: "Şifreyi Kurtar",
    },
    resetPassword: {
      title: "Yeni Parolanızı Belirleyin",
      subText:
        "Lütfen yeni şifrenizi belirlemek için e-postanızı, kodunuzu ve yeni şifrenizi girin",
      successMessage:
        "Şifre başarıyla değiştirildi. Lütfen yeni şifrenizle giriş yapın.",
      buttonText: "Şifre Sıfırla",
    },
    verifyCode: {
      title: "Hesabı Onayla",
      subText: "Onay kodu gönderildi. Lütfen E-postanızı kontrol ediniz.",
      buttonText: "Hesabı Onayla",
    },
    //***  Auth Pages End */
    notFoundPage: {
      title: "Sayfa Bulunamadı 🕵🏻‍♀️",
      text: "Oops! 😖 İstenen sayfa bu sunucuda bulunamadı.",
      button: "Platforma Geri Dön",
    },
    luminaries: {
      title: "Armatürler",
      addNewProject: "Yeni Proje Ekle",
      status: "Durum",
      updatedAt: "Güncellenme Tarihi",
      lastTestTime: "Son Test Zamanı",
      actionNeeded: "İhtiyaç Duyulan Eylem",
      noProjectInfoText: "Kayıtlı proje bulunmamaktadır.",
      hasNotDeviceInfoText: "Bu projeye ait cihaz bulunmamaktadır.",
      notSubscriptionMessage: "İçeriği görmek için lütfen abone olunuz.",
      projectName: "Proje Adı",
      notSubscriptionButton: {
        text: "Abone olmak için {button} tıklayınız.",
        button: "buraya",
      },
      add: {
        title: "Yeni Proje Ekle",
        projectName: "Proje Adı",
        successMessage: "İşlem Başarılı! Proje oluşturuldu.",
      },
      devices: {
        delete: {
          modalTitle: "Cihaz Sil",
          modalText: "Cihazı silmek istediğinizden emin misiniz?",
          successMessage: "İşlem Başarılı! Cihaz silindi.",
        },
      },
    },
    subscription: {
      subscriptionDetails: "Abonelik Ayrıntıları",
      validUntil: "Geçerlilik Tarihi: {date}",
      renewalDate: "Sonraki Ödeme Tarihi: {date}",
      expiryDate: "Son Kullanma Tarihi: {date}",
      subscriptionStartDate: "Abonelik Başlangıç Tarihi: {date}",
      totalLuminary: "Toplam Armatür: {luminary}",
      subscriptionPlan: "Abonelik Planı: {plan}",
      monthly: "Aylık",
      yearly: "Yıllık",
      subscriptionMonthly: "Aylık Abonelik",
      subscriptionYearly: "Yıllık Abonelik",
      cancelSubscription: "Aboneliği İptal Et",
      cancelSubscriptionModalText:
        "Aboneliğinizi iptal etmek istediğinizden emin misiniz?",
      cancelSubscriptionSuccessMessage:
        "İşlem Başarılı! Aboneliğiniz iptal edildi.",
      upgradeSubscription: "Aboneliği Yıllık Plana Yükselt",
      successMessage: "İşlem Başarılı! Abone oldunuz.",
      subscriptionStatus: "Abonelik Durumu",
      aMonthFreeTrial: {
        text: "İlk aboneliğinize özel {trial}",
        trial: "+1 Ay Ücretsiz Deneme",
      },
      daysRemaining: "{day} Gün Kaldı",
      subscribe: "Abone Ol",
      subscriptionStatusTypes: {
        INACTIVE: "AKTİF DEĞİL",
        ACTIVE: "AKTİF",
        PENDING: "BEKLİYOR",
        UNPAID: "ÜCRETSİZ",
        UPGRADED: "YÜKSELTİLDİ",
        CANCELED: "İPTAL EDİLDİ",
        EXPIRED: "SÜRESİ BİTMİŞ",
        PAYMENTDUE: "ÖDEME-VADE",
      },
      changePaymentMethod: "Ödeme Yöntemini Değiştir",
      subscriptionPayment: "Abonelik Ödemesi",
      paymentLoadInfoText:
        "Bilgileriniz kontrol ediliyor. Lütfen bekleyiniz...",
      paymentPageErrorText: "Hata! Bir şeyler yanlış gitti!",
      cancelOperation: "İşlemi İptal Et",
      paymentInformation: {
        title: "Ödeme Bilgileri",
        description: "Kredi kartı bilgilerini hiçbir zaman saklamayız.",
        cardNumber: "Kart Numarası",
        nameOnTheCard: "Kart Üzerindeki İsim",
        cvvTooltipText: "Enter a card CVV code",
        expirationDate: "Son Kullanma Tarihi",
        monthlySubscription: "Aylık abone",
        oneYearSubscription: "1 yıllık abonelik",
        threeYearSubscription: "3 yıllık abonelik",
      },
    },
    reports: {
      generateAReport: "Rapor Oluştur",
      retrieveAnOlderReport: "Daha Eski Bir Rapor Al",
      reportName: "Rapor Adı",
      notSubscriptionMessage: "İçeriği görmek için lütfen abone olunuz.",
      add: {
        successMessage: "İşlem Başarılı! Armatür için yeni rapor oluşturuldu.",
      },
    },
    settings: {
      timezone: {
        modalTitle: "Saat Dilimini Değiştir",
        selectTimezone: "Saat Dilimini Seçiniz",
        successMessage: "İşlem Başarılı! Saat dilimi değiştirildi.",
      },
      changePassword: {
        modalTitle: "Şifreyi Değiştir",
        successMessage:
          "İşlem Başarılı! Şifre başarıyla değiştirildi. Lütfen yeni şifrenizle giriş yapınız.",
        currentPasswordIsWrongMessage: "Mevcut şifre yanlış.",
      },
      billingInformation: {
        title: "Fatura Bilgileri",
        selectCountry: "Ülke Seçiniz",
        selectCity: "Şehir Seçiniz",
        successMessage: "İşlem Başarılı! Fatura bilgileri güncellendi.",
      },
    },
    administration: {
      title: "Yönetici Paneli",
      userGuides: "Kullanıcı Kılavuzları",
      newGuide: "Yeni Kılavuz",
      images: "Resimler",
      addText: "Metin Ekle",
      addTranslation: "Çeviri Ekle",
      isItActive: "Aktif mi?",
      add: {
        successMessage: "İşlem Başarılı! Yeni kılavuz oluşturuldu.",
      },
      edit: {
        title: "Kılavuzu Düzenle",
        successMessage: "İşlem Başarılı! Kılavuz güncellendi.",
      },
      detail: {
        selectLocale: "Dil Seçiniz",
        warningMessage: "Resim ve açıklamayı eklediğinizden emin olunuz.",
        successMessage: "İşlem Başarılı! Kılavuz güncellendi.",
      },
      delete: {
        modalTitle: "Kılavuz Sil",
        modalText: "Kılavuzu silmek istediğinizden emin misiniz?",
        successMessage: "İşlem Başarılı! Kılavuz silindi.",
        guideItem: {
          modalTitle: "Kılavuz Resmini Sil",
          modalText:
            "Bu kılavuzdan bu resmi kaldırmak istediğinizden emin misiniz?",
          successMessage: "İşlem Başarılı! Kılavuzdan resim silindi.",
        },
      },
    },
    contact: {
      title: "İletişim",
      subText: "Bilgilendirme için bize ulaşın.",
      successMessage: "İşlem Başarılı! Mesajınız alınmıştır.",
    },
    form: {
      message: {
        email: "Geçerli e-posta adresi olmalıdır",
        required: "Bu alan boş geçilemez.",
        passwordsMustMatch: "Şifreler eşleşmiyor",
        passwordsNotMustMatch: "Yeni şifre mevcut şifreden farklı olmalıdır.",
        numeric: "Bu alan yalnızca sayısal karakterler içerebilir.",
        cardNumber: "Kart bilgileri doğru olmalıdır.",
        min: "Bu alan en az {value} karakter olmalıdır.",
        select: "En az bir seçeneği seçiniz.",
        passwordRegex:
          "Bu alan en az bir sayı, bir küçük harf ve bir büyük harf içermelidir. Boşluk veya özel karakter içeremez.",
        passwordRegexFormat:
          "Bu alan en az bir sayı, bir küçük harf ve bir büyük harf içermelidir.",
        phoneNumberFormat:
          "Lütfen doğru telefon numarası girdiğinize emin olunuz.",
      },
    },
    datePicker: {
      startDate: "Başlangıç Tarihi",
      endDate: "Bitiş Tarihi",
      pickAMonth: "Bir ay seçiniz",
    },
    selectBox: {
      noDataText: "Veri yok",
      noMatchText: "Eşleşen veri yok",
    },
    table: {
      tableEmptyText: "Kayıt bulunamadı",
      emptyFilteredText: "Talebinizle eşleşen kayıt bulunamadı",
    },
    notify: {
      error: {
        error: "Hata",
        title: "Bir hata oluştu.",
        buttonText: "Lütfen tekrar deneyin!",
      },
      success: {
        success: "Başarılı",
        title: "İşlem Başarılı!",
        buttonText: "Devam et!",
      },
    },
    phoneNumberInput: {
      countrySelector: {
        placeholder: "Ülke kodu",
        error: "Ülke seçin",
      },
      phoneInput: {
        placeholder: "Telefon numarası",
        example: "Örnek:",
      },
    },
    buttons: {
      submit: "Gönder",
      approve: "Onayla",
      close: "Kapat",
      delete: "Sil",
      deleteDevice: "Cihazı Sil",
      save: "Kaydet",
      remove: "Kaldır",
      okey: "Tamam",
      repeat: "Tekrar",
      update: "Güncelle",
      cancel: "İptal",
      yes: "Evet",
      upload: "Yükle",
      download: "İndir",
      send: "Gönder",
      choose: "Seç",
      change: "Değiştir",
      selectAll: "Hepsini Seç",
      clear: "Temizle",
      tryAgain: "Tekrar Dene",
      start: "Başla",
      launch: "Başlat",
      continue: "Devam",
      edit: "Düzenle",
      yesIAccept: "Evet, Onaylıyorum",
      detail: "Detay",
    },
    awsCognitoErrorCodes: {
      InvalidPasswordException: "Parola yeterince uzun değil.",
      ExpiredCodeException: "Geçersiz kod, lütfen tekrar bir kod isteyin.",
      LimitExceededException:
        "Deneme sınırı aşıldı, lütfen bir süre sonra deneyin.",
      NotAuthorizedException: "Yanlış kullanıcı adı veya parola.",
      CodeMismatchException: "Geçersiz doğrulama kodu, lütfen tekrar deneyin",
      InvalidParameterException:
        "Girdiğiniz değer eksik veya girilen değer uzunluğu kısa.",
      PasswordResetRequiredException:
        "Kullanıcı için parola sıfırlama gerekli. Lütfen şifre sıfırlama talebinde bulunun.",
      UserNotFoundException: "Kullanıcı bulunamadı.",
      UserNotConfirmedException: "Kullanıcı onaylanmadı.",
      UsernameExistsException:
        "Bu e-posta adresiyle kayıtlı bir kullanıcı zaten var. Lütfen başka bir e-posta adresi ile kayıt olunuz.",
    },
    errorCodes: {
      errorMsg: "Bir hata oluştu. Lütfen tekrar deneyiniz.",
      UserAttributesRequired:
        "Abonelik için fatura bilgileriniz eksik. Lütfen gerekli bilgileri doldurunuz.",
      "500": "Dahili Sunucu Hatası",
      "404": "İstenen kaynak mevcut değil",
      "409": "İstenen kaynak mevcut",
    },
    iyzicoErrorCodes: {
      InvalidEmailAddress: "Geçersiz e-posta adresi.",
      InvalidIdentityNumber: "Geçersiz kimlik numarası.",
      InvalidPhoneNumber: "Geçersiz telefon numarası.",
      InvalidAddress: "Geçersiz adres.",
      InvalidCity: "Geçersiz şehir bilgisi.",
      InvalidCountry: "Geçersiz ülke bilgisi.",
      RetryAgainLater: "Lütfen işlemi daha sonra yeniden deneyin.",
    },
  },
};

let locale =
  navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language;

locale = locale.includes("-") ? locale.split("-")[0] : locale;

const languages = ["en", "tr", "fr"];

if (!window.localStorage.getItem("lang")) {
  window.localStorage.setItem(
    "lang",
    languages.includes(locale) ? locale : "en"
  );
}
const currentLang = window.localStorage.getItem("lang");

const i18n = createI18n({
  legacy: false,
  locale: currentLang ? currentLang : "en",
  globalInjection: true,
  messages,
});

export default i18n;
